// Enabled via ?perf=1 — zero cost when not active.
// Builds cells once on init and only updates textContent each tick, so the
// overlay itself doesn't churn DOM nodes (which would pollute the very memory
// profiling it's meant to support).

export function createOverlay(gallery) {
    const el = document.createElement('div');
    el.style.cssText = [
        'position:fixed', 'bottom:12px', 'left:12px', 'z-index:99999',
        'background:rgba(0,0,0,0.75)', 'color:#0f0', 'font:11px/1.6 monospace',
        'padding:8px 10px', 'border-radius:4px', 'pointer-events:none',
        'white-space:pre',
    ].join(';');
    document.body.appendChild(el);

    const peaks = {};
    const rows  = [];
    // [ label, statKey, isMin (track min instead of max for peak) ]
    const defs = [
        ['Heap MB',   'heapMB',   false],
        ['Bytes MB',  'bytesMB',  false], // estimated VRAM in cached textures
        ['GL Texs',   'glTexs',   false], // Pixi's actual managed-texture set size
        ['FPS',       'fps',      true ],
        ['Sprites',   'sprites',  false],
        ['Cached',    'cached',   false],
        ['Queue',     'queue',    false],
        ['Loading',   'loading',  false],
        ['Frame ms',  'frameMs',  false],
        ['Scene ms',  'sceneMs',  false],
        ['Render ms', 'renderMs', false],
        ['Zoom',      'zoom',     false],
        ['Tier',      'tier',     false],
    ];

    // Build the row DOM once. Each row: <div><span>label</span><span val></span><span peak></span></div>
    for (const [label, key, isMin] of defs) {
        const row = document.createElement('div');
        const lbl = document.createElement('span');
        const val = document.createElement('span');
        const pk  = document.createElement('span');
        lbl.textContent = label.padEnd(10);
        val.style.cssText = 'display:inline-block;min-width:5ch;text-align:right;margin-right:8px';
        pk.style.color  = '#f44';
        row.append(lbl, val, pk);
        el.appendChild(row);
        rows.push({ key, isMin, val, pk });
    }

    setInterval(() => {
        const s = gallery._stats;
        if (!s) return;
        for (const { key, isMin, val, pk } of rows) {
            const v = s[key];
            val.textContent = v ?? '--';
            const n = parseFloat(v);
            if (!isNaN(n)) {
                if (peaks[key] === undefined) peaks[key] = n;
                peaks[key] = isMin ? Math.min(peaks[key], n) : Math.max(peaks[key], n);
                pk.textContent = peaks[key];
            }
        }
    }, 250);
}
